import React from 'react'
import SliderSlick from 'react-slick'
import './Slider.css'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

class Slider extends React.Component {


  render() {
    const settings = {
      dots: true,
      arrows: true,
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1
    }

    return (
      <div className="Slick-slider-carousel-menu">
        <SliderSlick ref={slider => (this.slider = slider)} {...settings}>
          {this.props.children}
        </SliderSlick>
      </div>
    )
  }
}

export { Slider }



// WEBPACK FOOTER //
// ./src/content/chapters/02/02/components/Slider.js